module.exports = __webpack_public_path__ + "static/media/clear-light-icon.ca288ef6.svg";